import React, { FC } from "react"
import { useSelector } from "react-redux"
import _ from "lodash"

import { isBlank } from "@/utils"
import {
  getSectionFieldNames,
  countIncompleteRequiredFields,
  getField,
  getSectionChat,
  getSettings,
  countChangedFields,
} from "@/onboarding/features/product/selectors"
import { ReservedFields, ReservedSections } from "@/onboarding/features/product/models/Product"

import SectionHolder from "./shared/SectionHolder"
import Overview from "./tour_itinerary/Overview"
import Timeline from "./tour_itinerary/Timeline"

const TourItinerary: FC = () => {
  const fieldNames = useSelector(getSectionFieldNames.tourLocation)
  const { tour_stops } = useSelector(getSettings(ReservedFields.TOUR_STOPS))

  const tourStopsField = useSelector(getField(ReservedFields.TOUR_STOPS))
  const sectionChat = useSelector(getSectionChat(_.snakeCase("tourStops")))

  // tour_destination stays out of the static tourLocation list (see the
  // overview Edit form: unconditional inclusion would submit it on documents
  // that don't carry it), so its change flag joins the section count here.
  const tourDestinationSettings = useSelector(getSettings(ReservedFields.TOUR_DESTINATION))
  const tourDestinationChanged =
    tourDestinationSettings[ReservedFields.TOUR_DESTINATION]?.changed ?? false

  const incompleteFieldCount = useSelector((state) => {
    const baseCount = countIncompleteRequiredFields(...fieldNames)(state)

    return isBlank(tourStopsField.value) && tourStopsField.required ? baseCount + 1 : baseCount
  })

  const proposedChangesCount = useSelector((state) => {
    const baseCount = countChangedFields(...fieldNames)(state)

    return baseCount + (tour_stops.changed ? 1 : 0) + (tourDestinationChanged ? 1 : 0)
  })

  return (
    <SectionHolder
      title="Tour Itinerary"
      name={ReservedSections.TOUR_STOPS}
      importableFields={[...fieldNames, ReservedFields.TOUR_STOPS]}
      incompleteRequiredFieldCount={incompleteFieldCount}
      chat={sectionChat}
      proposedChangesCount={proposedChangesCount}
      changedComponent={tour_stops.changed}
    >
      <div className="d-flex flex-column gap-2">
        <Overview />
        <Timeline
          requiredField={tourStopsField.required}
          incompleteField={isBlank(tourStopsField.value)}
          previousStops={tour_stops.previousValue}
        />
      </div>
    </SectionHolder>
  )
}
export default TourItinerary
